import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import {Provider} from "mobx-react";
import { stores } from "./stores";
import ReactGA from 'react-ga';
//import { createBrowserHistory } from 'history';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

//const history = createBrowserHistory();
ReactGA.initialize('UA-150888308-1');
// Initialize google analytics page view tracking
// history.listen(location => {
//     ReactGA.set({ page: location.pathname }); // Update the user's current page
//     ReactGA.pageview(location.pathname); // Record a pageview for the given page
//     console.log('GA', location.pathname);
//   });

ReactDOM.render(
    <Provider {...stores}>
        <BrowserRouter basename={baseUrl}>
            <App />
        </BrowserRouter>
    </Provider>,
  rootElement);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js